import {
  Button,
  Col,
  Container,
  Dropdown,
  Image,
  Navbar,
  Row,
} from "react-bootstrap";
import error_img from "../../assets/images/404.svg";
import "./error404.css";
import { useTranslation } from "react-i18next";

export const Error404Screen = () => {
  const { t } = useTranslation();

  return (
    <>
      <Container className="content-error-page mt-4 px-4">
        <Row>
          <Container className="py-1">
            <Row className="content-section error-section">
              <Col lg={12} className="error-text">
                <h1 className="error-text-red ">404</h1>
                <p>
                  {t("error404.info-text.black")} {t("error404.info-text.red")}
                </p>
              </Col>
              <Col lg={12} className="mt-5" style={{ textAlign: "center" }}>
                <Image src={error_img} fluid="true" />
              </Col>
            </Row>
          </Container>
        </Row>
      </Container>
    </>
  );
};
